import WOW from "wowjs";
import Typed from "typed.js";

import "./index.css";
import "../home/components/navigation/navigation";
import "./components/scene-1/scene-1";
import "./components/scene-2/scene-2";

import "../analytics";

const textAnimation = document.querySelector(".anime");

var wow = new WOW.WOW({
  boxClass: "wow", // default
  animateClass: "animated", // default
  offset: 0, // default
  mobile: true,
  live: false,
});
wow.init();

var options = {
  strings: ["Think, Design, Create - Repeat"],
  typeSpeed: 60,
  showCursor: true,
};

function callback() {
  new Typed(".anime", options);
}

document.addEventListener("scroll", () => {
  if (isInViewport(textAnimation)) {
    callback();
    // eslint-disable-next-line
    callback = function empty() {};
  }
});

const isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};
